export default __webpack_public_path__ + "static/media/empty-homework.944bdd28.png";